<template>
  <div class="input_container">
    <label :for="inputId" class="input_label">
      <span>{{ label }}</span>
      <div class="tooltip" v-if="tooltip && !disabled">
        <TooltipComponent :text="tooltip" position="top"></TooltipComponent>
      </div>
    </label>


    <input
        :disabled="disabled"
        :id="inputId"
        type="date"
        v-model="selectedDate"
        :min="minDate"
        :max="maxDate"
        :class="[{ 'is-placeholder': selectedDate=='' }, { 'has-error': hasError }]"
        class="input-field"
    />
  </div>
  <!-- Error message -->
  <span v-if="hasError" class="error-message">{{ errorMessage }}</span>
</template>

<script setup lang="ts">
import { ref, watch, defineEmits, defineProps } from 'vue';
import TooltipComponent from '@/components/common/TooltipComponent/TooltipComponent.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  label: {
    type: String,
    default: 'Select a date',
  },
  minDate: {
    type: String,
    default: '',
  },
  maxDate: {
    type: String,
    default: '',
  },
  id: {
    type: String,
  },
  modelValue: {
    type: String,
    default: '',
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
  tooltip: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const selectedDate = ref(props.modelValue);
const inputId = `date-picker-${Math.random().toString(36).substr(2, 9)}`;

watch(selectedDate, (newValue) => {
  const dateToNumber = Date.parse(newValue)
  if(props.minDate!=''){
    const minDateToNumber = Date.parse(props.minDate);
    if(dateToNumber-minDateToNumber<0){
      selectedDate.value = props.minDate;
    }
  }
  if(props.maxDate!=''){
    const maxDateToNumber = Date.parse(props.maxDate);
    console.log(maxDateToNumber-dateToNumber)
    if(maxDateToNumber-dateToNumber<0){
      selectedDate.value = props.maxDate;
    }
  }
  emit('update:modelValue', newValue);
});

watch(
    () => props.modelValue,
    (newValue) => {
      selectedDate.value = newValue;
    }
);
</script>

<style lang="scss" scoped>
@import 'DatePickerComponent';
</style>